import type { SVGProps } from 'react';
import { Comment16, Heart16 } from '@elfsight/icons';

export interface CounterBlock<T extends string = string> {
  title: T;
  count: string;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
}

const likes: CounterBlock<'Like'> = {
  // t('Like')
  title: 'Like',
  count: '{{count}} Likes',
  icon: Heart16
};

const comments: CounterBlock<'Comment'> = {
  // t('Comment')
  title: 'Comment',
  count: '{{count}} Comments',
  icon: Comment16
};

export const counters = {
  likes,
  comments
};
